import { toast } from "react-hot-toast";

export function fetchAndDownloadData(fileUrl: string, fileName: string): void {
  fetch(process.env.REACT_APP_BASE_URL + fileUrl, {})
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      const splited = fileUrl.split("/");
      link.setAttribute("download", splited[splited.length - 1]);
      document.body.appendChild(link);
      link.click();
      // Yaratilgan linkni tozalash
      document.body.removeChild(link);
    })
    .catch((error) => {
      toast.error("Ma'lumot yuklashda xatolik yuz berdi");
    });
}
